import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// API call thunk
export const fetchFinancialYears = createAsyncThunk("financialYear/fetchFinancialYears",
  async () => {
    const response = await fetch(
      process.env.REACT_APP_BASE_URL + "/financialyear/getFinancialYearList",
      { method: "GET" }
    );

    const data = await response.json();
    const activeYearObj = data?.find((fy) => fy.activeYear === true);
    return {
      list: data?.map((fy) => ({
        value: fy.financialYear,
        label: fy.financialYear,
      })),
      defaultFinancialYear: activeYearObj?.financialYear || data?.[0]?.financialYear || "2026-2027",
    }
  }
);

// const getCurrentFinancialYear = () => {
//   const today = new Date();
//   const year = today.getFullYear();
//   const month = today.getMonth() + 1;

//   if (month >= 4) {
//     return `${year}-${year + 1}`;
//   } else {
//     return `${year - 1}-${year}`;
//   }
// };

const initialState = {
  activeNumberKey: 0,
  newDashboard: { activeKey: 1, subActivekey: 1, activeTab: 'Dashboard' },
  activeMenu: { activeKey: 0, activeTab: 'old Dashboard' },
  financialYear: "2026-2027",
  financialYearList: [],
  fyLoading: false,
};

const sidebarSlice = createSlice({
  name: 'activeKey',
  initialState,
  reducers: {
    setActiveKey(state, action) {
      state.activeNumberKey = action.payload
    },
    setActiveMenu(state, action) {
      state.activeMenu = { ...state.activeMenu, ...action.payload }
    },
    setNewActiveKey(state, action) {
      state.newDashboard = { ...state.newDashboard, ...action.payload }
    },
    setFinancialYear(state, action) {
      state.financialYear = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinancialYears.pending, (state) => {
        state.fyLoading = true;
      })
      .addCase(fetchFinancialYears.fulfilled, (state, action) => {
        state.fyLoading = false;
        state.financialYearList = action.payload?.list || [];
        state.financialYear = action.payload.defaultFinancialYear;
      })
      .addCase(fetchFinancialYears.rejected, (state) => {
        state.fyLoading = false;
      });
  },
});

export const { setActiveKey, setActiveMenu, setNewActiveKey, setFinancialYear } = sidebarSlice.actions;
export default sidebarSlice.reducer;